import { ADMIN, COLUMNS, LOGS, USERS } from "@/constant/routes";
import AdminColumns from "@/features/admin/components/admin-columns/AdminColumns";
import { AdminLogs } from "@/features/admin/pages/admin-logs/AdminLogs";
import Admin from "@/features/admin/pages/admin";
import AdminUsers from "@/features/admin/pages/admin-users/AdminUsers";
import { Navigate } from "react-router-dom";

export const routes = [
    {
      path: ADMIN,
      element: <Navigate to="/admin/users" replace />,
      isPublic: false,
    },
    {
      path: USERS,
      element: <Admin><AdminUsers /></Admin>,
      isPublic: false,
    },
    {
      path: COLUMNS,
      element: <Admin><AdminColumns /></Admin>,
      isPublic: false,
    },
    {
      path: LOGS,
      element: <Admin><AdminLogs /></Admin>,
      isPublic: false,
    },
];